<template>
  <div style="margin-right:15px;">
    <img style="height:14px;width:14px;margin-right:5px;" src="~@/assets/img/icons/searchbar-black-icon.png" alt="search-icon">
    <input :placeholder="$t('admin.rechercher')" v-model="test" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      search: "",
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    ...mapGetters(["insight_search"]),
    test: {
      get: function() {
        return this.insight_search;
      },
      set: function(search) {
        this.$store.commit("INSIGHT_SEARCHBAR", search);
      },
    },
  },
  created() {
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.windowWidth = window.innerWidth;
      });
    });
  },
};
</script>
